import React from 'react'

export default function UserInfo() {
  return (
    <div>
      
    </div>
  )
}
